import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import colors from "../styles/colors";

type CheckIconProps = {
display: boolean
size: any
};

const CheckIcon = (props: CheckIconProps) => {
  const { display, size} = props;

  return (
    
<FontAwesomeIcon
icon={faCheck}
color={colors.selectedBorder}
size={size}
style={{
  display: display ? "block" : "none"
}}
/>
  );
};

export default CheckIcon;











